import { render } from "./USHub.vue?vue&type=template&id=85bd62e4"
import script from "./USHub.vue?vue&type=script&lang=js"
export * from "./USHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__